<template>
  <TheNuxtLink
    :id="itemData.trackingCode"
    :title="itemData.name"
    :to="provideFormatUrl(itemData.link)"
    :class="hasThumbnail ? 'flex' : 'block'"
    class="overflow-hidden rounded bg-white shadow-normal shadow-gray-400"
  >
    <div class="p-3" :class="hasThumbnail && 'flex-1'">
      <div class="mb-2" :class="hasIcon && 'flex items-center'">
        <figure
          v-if="hasIcon"
          class="mr-2 h-[46px] w-[46px] basis-[46px] overflow-hidden rounded-lg border border-solid border-gray-400 shadow-normal shadow-gray-400"
        >
          <img
            :src="contextIconUrl"
            :alt="itemData.name || itemData.description"
            loading="lazy"
            class="pointer-events-none block h-full w-full object-contain"
          />
        </figure>
        <h3 class="line-clamp-2 flex-1 text-sm font-bold">
          {{ itemData.name }}
        </h3>
      </div>
      <p class="line-clamp-3 w-full text-sm text-gray-600">
        {{ itemData.description }}
      </p>
    </div>
    <figure
      v-if="hasThumbnail"
      class="relative block h-[140px] w-[120px] basis-[120px] overflow-hidden"
    >
      <img
        :src="contextThumbnail"
        :alt="itemData.name || itemData.description"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
      />
    </figure>
  </TheNuxtLink>
</template>

<script setup lang="ts">
  import type { IItem as IListProductItem } from '@/components/Shared/Suite/ListProduct/index.vue';
  import type { IItem as ISuiteProductItem } from '@/components/Shared/Suite/SuiteProduct/index.vue';
  import type { TUrlConnector } from '@/components/Shared/Suite/type.ts';

  interface IProps {
    itemData: IListProductItem | ISuiteProductItem;
    urlConnector?: TUrlConnector;
  }

  const props = defineProps<IProps>();

  const { provideFormatUrl } = useFormatUrl();
  const { provideResponsiveImgUrl, provideImgUrl } = useSolutionsData();

  const contextThumbnail = computed((): string => {
    const { thumbnail } = props.itemData;
    if (!thumbnail) return '';

    if (props.urlConnector === 'solution') {
      return provideResponsiveImgUrl(thumbnail);
    }
    return thumbnail;
  });

  const contextIconUrl = computed((): string => {
    const { iconThumbnail } = props.itemData;
    if (!iconThumbnail) return '';

    if (props.urlConnector === 'solution') {
      return provideImgUrl(`${iconThumbnail}.webp`);
    }
    return iconThumbnail;
  });

  const hasIcon = computed((): boolean => !!props.itemData.iconThumbnail);

  const hasThumbnail = computed((): boolean => !!props.itemData.thumbnail);
</script>
